/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import 'index.scss';
import { Provider } from 'react-redux';
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import reducer from "store/reducer";
import * as serviceWorker from 'serviceWorker';
import {sagas} from "store/saga";
import Router from "features/router";
import { routerMiddleware, ConnectedRouter } from 'connected-react-router';
import {historyObject} from "historyObject.js";
import {createMocks} from "services/api/mocks";
import { ToastProvider } from 'react-toast-notifications'
import {Toast} from "features/components/toast";
import { save, load } from "redux-localstorage-simple"
import {initialState as companyInitialState} from "store/reducer/company/reducer";
import {initialState as userInitialState} from "store/reducer/user/profile/reducer";
import {initialState as staticInitialState} from "store/reducer/static/reducer";
import {Elements} from '@stripe/react-stripe-js';
import {StripePromise} from "stripe";
import moment from "moment";
import 'moment/locale/it';
import {setupAxiosInterceptors} from "services/api/client";
import {resetAuth} from "store/reducer/auth/reducer";
import {loginError} from "features/pages/account/login/reducer";
import {startErrorHandler} from "errorReporting";

moment.locale("it");

const devMode = process.env.NODE_ENV === "development";
const sagaMiddleware = createSagaMiddleware();

const middleware = [
    ...getDefaultMiddleware({ thunk: false }),
    sagaMiddleware,
    routerMiddleware(historyObject),
    save({states: ["company", "user", "static_data"], namespace: "CERCHIA", debounce: 500})
];

const store = configureStore({
    reducer: reducer,
    devTools: devMode,
    middleware,
    preloadedState: load({
        states: ["company", "user", "static_data"],
        namespace: "CERCHIA",
        preloadedState: {
            company: companyInitialState,
            user: {
                profile: userInitialState
            },
            static_data: staticInitialState
        }
    })
});

setupAxiosInterceptors(() => {
    store.dispatch(resetAuth());
    store.dispatch(loginError("common.token-expired"));
    historyObject.replace("/login");
});

sagaMiddleware["run"](sagas);

if (devMode && module["hot"]) {
    module["hot"].accept("./store/reducer/index.js", () => store.replaceReducer(reducer));
}
if(process.env.REACT_APP_MOCKS === "true") {
    createMocks(process.env.REACT_APP_ENABLE_MOCK_ERROR === "true");
}

startErrorHandler()

ReactDOM.render(
    <ToastProvider components={{ Toast: Toast }} placement={"bottom-right"} autoDismiss={true} >
        <React.StrictMode>
            <Elements stripe={StripePromise}>
                <Provider store={store}>
                    <ConnectedRouter history={historyObject}>
                        <Router />
                    </ConnectedRouter>
                </Provider>
            </Elements>
        </React.StrictMode>
    </ToastProvider>,
  document.getElementById('root')
);

// If you want your store to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
